/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-08T14:20:04+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-08T14:38:19+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * MColumnsForm - …
**/

class MColumnsForm extends Component {
  render() {
    const {
      children,
      ...other
    } = this.props;
    const childrenInColumns = React.Children.map(children, (child) => (
		        <div className="m-columns-form__column">{child}</div>
		    ));
		    return (
		        <div {...other} className="m-columns m-columns-form">
		            {childrenInColumns}
		        </div>
		    );
  }
}
MColumnsForm.propTypes = {
  children: PropTypes.any,
};
MColumnsForm.defaultProps = {};
export default MColumnsForm;

